import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { REACT_APP_I18_LANG } from "./config";

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .init({
    debug: false,
    showSupportNotice: false,
    lng: REACT_APP_I18_LANG,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          login_page: {
            login_title_text: "login",
            username_text: "username",
            password_text: "password",
            button_text: "login",
          },
          header: {
            name: "MONITOR",
            about: "About",
            dns_monitor: "DNS Monitor",
            contacts: "Contacts",
            stat: "Statistic",
          },
          navigation: {
            manual_add: "Manual",
            excel_upload: "Excel",
            publish: "Publish",
            punch_card: "Punch card",
          },
          publish: {
            title: "Publish",
            description:
              "Welcome to the publish page. Here you can manage and publish content.",
            content_management: "Content Management",
            create_new: "Create New",
            draft_management: "Manage Drafts",
            publish_content: "Publish Content",
            recent_activity: "Recent Activity",
            no_recent_activity: "No recent activity to display.",
          },
          stat: {
            outage_reports_amount: "Outage reports",
            shutdowns_types_amount: "Shatdowns types",
            network_anomailes: "Network anomailes",
            radial_diagram: {
              header: "Outage types",
              subtitle: "Planned outage and crisis managment",
              planned_outage: "planned outage",
              crisis_managment: "crisis managment",
            },
            collum_diagram: {
              header: "Outage frequency",
              data_label: "Amount of shutdowns by months",
              subtitle: "????",
              month: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dec",
              ],
            },
            collum_diagram2: {
              title: "Amount of shutdowns by days",
              subtitle: "in ",
              months: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dec",
              ],
              data_label: "Amount of shutdowns in regions for every day",
            },
          },
          choose: {
            header: "What stopped working?",
            internet: "Communication/Internet",
            vpn: "VPN service",
            other: "Other services",
          },
          user_report: {
            header: "To report an outage, fill out the form:",
            region: {
              placeholder: "Region",
              label: "Specify your region",
            },
            operator: {
              placeholder: "Operator",
              label: "Specify your operator",
            },
            internet_type: {
              placeholder: "Internet type",
              label: "Specify internet type",
            },

            vpn: {
              placeholder: "VPN",
              label: "Write the name of the VPN, or select from the list",
            },
            service: {
              placeholder: "Service",
              label: "Write the name of the service, or select from the list",
            },
            comment: {
              label: "Comment",
            },
            button: "Report an outage",
          },
          thank_you: {
            tg_bot: "Our telegram bot",
            tg_channel: "Our telegram channel",
            subscribe:
              "And don't forget to subscribe to our telegram channel to always know what to do in case of failures",
          },
          hero: {
            report_an_outage: "Report an outage",
            vpn: {
              title: "VPN protocols",
              description:
                "Workability of various protocols to ensure secure communication channels",
            },
            messengers: {
              title: "Messengers",
              description:
                "Availability of popular and alternative messengers in the region",
            },
            social_networks: {
              title: "Social networks",
              description: "Workability of global and local social networks",
            },
            streaming_services: {
              title: "Streaming services",
              description: "Availability of streaming services",
            },
            professional_tools: {
              title: "Professional tools",
              description:
                "Functioning of various tools required in work and business tasks",
            },
            other_services: {
              title: "Other services",
              description:
                "The functionality of other online services that are important to you",
            },
          },
        },
      },
      ru: {
        translation: {
          shutdown_add_page: {
            add_button_text: "добавить",
            success_message: "успешно добавлено!",
            error_message: "ошибка: ",
            region: "регион",
            error_no_date: 'поле "дата" не должно быть пустым',
            error_empty: "выбери хотя бы один шатдаун для добавления",
          },
          login_page: {
            login_title_text: "вход",
            username_text: "логин",
            password_text: "пароль",
            button_text: "войти",
          },
          header: {
            name: "МОНИТОР РУНЕТА",
            about: "О нас",
            dns_monitor: "DNS Monitor",
            contacts: "Контакты",
            stat: "Статистика",
          },
          navigation: {
            manual_add: "Вручную",
            excel_upload: "Excel",
            publish: "Публикация",
            punch_card: "Вручную",
          },
          publish: {
            title: "Публикация",
            description:
              "Добро пожаловать на страницу публикации. Здесь вы можете управлять и публиковать контент.",
            content_management: "Управление контентом",
            create_new: "Создать новый",
            draft_management: "Управление черновиками",
            publish_content: "Опубликовать контент",
            recent_activity: "Недавняя активность",
            no_recent_activity: "Нет недавней активности для отображения.",
          },
          stat: {
            outage_reports_amount: "Блокировок сервисов",
            shutdowns_types_amount: "Типов сетевых аномалий",
            network_anomailes: "Зафиксированных инцидентов",
            radial_diagram: {
              header: "Типы сетевых аномалий",
              subtitle: "Запланированные и не запланированные отключения",
              planned_outage: "Запланированные отключения ",
              crisis_managment:
                "Кризис-менеджмент это отключения как реакция власти на раздичные события и массовые собрания людей",
            },
            collum_diagram: {
              title: "Общее количество шатдаунов по месяцам",
              subtitle:
                "На графике представлена частота сетевых аномалий по месяцам за 2025 год",
              data_label:
                "Общее количество зафиксированных за месяц шатдаунов по всем регионам",
              month: [
                "янв",
                "фев",
                "мар",
                "апр",
                "май",
                "июн",
                "июл",
                "авг",
                "сен",
                "окт",
                "ноя",
                "дек",
              ],
            },
            collum_diagram2: {
              title: "Общее количество шатдаунов по дням",
              subtitle: "за ",
              months: [
                "январь",
                "февраль",
                "март",
                "апрель",
                "май",
                "июнь",
                "июль ",
                "август",
                "сентябрь",
                "октябрь",
                "ноябрь",
                "декабрь",
              ],
              data_label:
                "Общее количество зафиксированных за день шатдаунов по всем регионам ",
            },
            map: {
              header: "Карта сетевых аномалий",
              subtitle: "Ограничения связи по регионам за",
            },
          },
          choose: {
            header: "Что перестало работать?",
            internet: "Связь/интернет",
            vpn: "VPN сервис",
            other: "Другие сервисы",
          },
          user_report: {
            header: "Для сообщения о сбое выполните форму:",
            region: {
              placeholder: "Регион",
              label: "Укажите свой регион",
            },
            operator: {
              placeholder: "Оператор",
              label: "Укажите оператора связи или провайдера",
            },
            internet_type: {
              placeholder: "Тип интернета",
              label: "Укажите тип интернета",
            },

            vpn: {
              placeholder: "VPN",
              label: "Напишите название vpn или выберите из списка",
            },
            service: {
              placeholder: "Сервис",
              label: "Напишите название сервиса или выберите из списка",
            },
            comment: {
              label: "Комментарий",
            },
            button: "Сообщить о сбое",
          },
          thank_you: {
            tg_bot: "Наш телеграмм бот",
            tg_channel: "Наш телеграмм канал",
            subscribe:
              "И не забудь подписаться на наш телеграм канал, чтобы всегда знать,что делать в случае сбоев.",
          },
          hero: {
            report_an_outage: "Сообщить о сбое",
            vpn: {
              title: "Протоколы VPN",
              description:
                "Работоспособность различных протоколов для обеспечения безопасности каналов связи",
            },
            messengers: {
              title: "Мессенджеры",
              description:
                "Доступность популярных и альтернативных мессенджеров в России",
            },
            social_networks: {
              title: "Соцсети",
              description:
                "Работоспособность отечественных и зарубежных социальных сетей",
            },
            streaming_services: {
              title: "Стриминговые платформы",
              description: "Доступность сервисов с медиа-контентом",
            },
            professional_tools: {
              title: "Профессиональные инструменты",
              description:
                "Функционирование различных инструментов, необходимых в рабочих и бизнес задачах",
            },
            other_services: {
              title: "Прочие сервисы",
              description: "Исправность других важных для вас онлайн-сервисов",
            },
          },
        },
      },
    },
  });

export default i18n;
